import React, { useContext, useEffect, useLayoutEffect, useState } from "react"
import { connect } from "react-redux"
import { ChatSocketContext } from "../../Networking/chatSocketContext"
import Sidebar from "react-sidebar"
import ChatSidebarContent from "./ChatSidebar"
import ChatLog from "./ChatLog"
import "../../../assets/scss/pages/app-chat.scss"
import { ContextLayout } from "../../../utility/context/Layout"
const mql = window.matchMedia(`(min-width: 992px)`)

const MiniChat = ({ ...props }) => {
  const context = useContext(ChatSocketContext);

  const [state, setState] = useState({
    userProfile: false,
    sidebarDocked: mql.matches,
    sidebarOpen: false,
    activeChatID: null,
    activeChat: null,
    activeUser: null,
    isOpened: false,
  })

  const handleActiveChat = (id, user, chats) => {
    console.log(id)
    setState({
      ...state,
      activeChatID: id,
      activeUser: user,
      activeChat: chats,
      sidebarOpen: id == null,
      sidebarDocked: id == null
    })

  }

  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);

    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
  }

  const [width, height] = useWindowSize();
  const [chatAppHeight, setChatAppHeight] = useState(0)

  useEffect(() => {
    let element = document.getElementsByClassName("chat-application")[0];
    console.log(element.offsetHeight)
    setChatAppHeight(element.offsetHeight)
  }, [height])

  useEffect(() => {
    if (context.initialChatCheck == true) {
      setState({
        ...state,
        isOpened: true
      })
    }
  }, [context.chats])

  const toggleOpened = () => {
    setState({
      ...state,
      isOpened: !state.isOpened
    })
  }

  return (
    <div
      style={{
        right: 0,
        bottom: -8,
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        overflow: 'hidden',
        // bottom: "calc(20vw * -0.7)",
        marginBottom: state.isOpened ? 0 : (-chatAppHeight * 0.8) + 65,
        backgroundColor: 'white',
        transform: 'scale(0.8, 0.8)',
        transformOrigin: '100% 100%',
      }}
      className="chat-application position-fixed">
      {/* <div
        className={`chat-overlay ${state.sidebarOpen
          ? "show"
          : "d-none"
          }`}
      /> */}
      <ContextLayout.Consumer>
        {context => (
          <Sidebar
            sidebar={
              <ChatSidebarContent
                isMini={true}
                activeChatID={state.activeChatID}
                handleActiveChat={handleActiveChat}
                isOpened={state.isOpened}
                toggleOpened={toggleOpened}
              // mainSidebar={onSetSidebarOpen}
              />
            }
            docked={state.sidebarDocked}
            open={state.sidebarOpen}
            touch={true}
            sidebarClassName="chat-sidebar"
            contentClassName="sidebar-children d-none"
            pullRight={context.state.direction === "ltr"}>
            ""
          </Sidebar>
        )}
      </ContextLayout.Consumer>
      <ChatLog
        isMini={true}
        activeChat={state.activeChat}
        activeUser={state.activeUser}
        // mainSidebar={this.onSetSidebarOpen}
        mql={mql}
        handleActiveChat={handleActiveChat}
      />
    </div>
  )
}

const mapStateToProps = state => {
  return {
    clinicUserinfo: state.clinicUser.clinicUserinfo
  }
}
export default connect(mapStateToProps, {})(MiniChat)